import { useParams } from "react-router-dom";
import { useTranslate } from "helpers";

import { Routes as SalesRoutes } from "ui/modules/sales/navigation/routes";
import { getInquiryAPI } from "services/api/sales/inquiries/api";
import { useApiCall } from "services/api/hooks/useApiCall";

import { InquiryDetailPageCmp } from "./types";
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Loader } from "ui/components/Loader";

import { SALES_INQUIRY_DETAIL_PAGE_TITLE } from "ui/components/PageTitle/consts";

const InquiryDetailPage: InquiryDetailPageCmp = () => {
  const { id } = useParams();
  const { t } = useTranslate();

  const { data: inquiry, isLoading } = useApiCall(
    () => getInquiryAPI(id!),
    [id],
    { onNotFound: SalesRoutes.InquirySearchPageRouter }
  );

  if (!id) return <></>;
  if (isLoading || !inquiry) return <Loader isLoading={true}>{null}</Loader>;

  return (
    <>
      <div>
        <div className="bg-white rounded-t-md border border-b mb-2">
          <PageHeader>
            <PageTitle
              title={`${t(SALES_INQUIRY_DETAIL_PAGE_TITLE.text)} [${inquiry.customerName ?? ""}]`}
              icon={SALES_INQUIRY_DETAIL_PAGE_TITLE.icon}
              iconColor={SALES_INQUIRY_DETAIL_PAGE_TITLE.iconColor}
            />
            <Breadcrumb />
          </PageHeader>
        </div>
        <div className="px-0 pt-2 mx-[-1px] xl:px-6">
          <div className="bg-white rounded-md border p-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.source")}</span>
                <p className="font-medium">{inquiry.inquirySourceName}</p>
              </div>
              <div>
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.status")}</span>
                <p className="font-medium uppercase">{inquiry.status}</p>
              </div>
              <div>
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.customer")}</span>
                <p className="font-medium">{inquiry.customerName}</p>
              </div>
              <div>
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.email")}</span>
                <p className="font-medium">{inquiry.customerEmail}</p>
              </div>
              <div>
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.phone")}</span>
                <p className="font-medium">{inquiry.customerPhone}</p>
              </div>
              <div>
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.assigned")}</span>
                <p className="font-medium">{inquiry.assignedUserName ?? "-"}</p>
              </div>
              <div className="col-span-2">
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.message")}</span>
                <p className="font-medium whitespace-pre-wrap">{inquiry.message ?? "-"}</p>
              </div>
              <div className="col-span-2">
                <span className="text-sm text-gray-500">{t("admin.sales.inquiry.detail.notes")}</span>
                <p className="font-medium whitespace-pre-wrap">{inquiry.notes ?? "-"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

InquiryDetailPage.route = SalesRoutes.InquiryDetailPageRouter;

export default InquiryDetailPage;
